<template>
    <div class="video-wrapper">
    <div class="video-player circle circle--video">
        <div>
            <transition name="fade">
                <div ref="play" v-show="ended" :class="{
                    'control control--play': 1,
                    'control--custom' : custom
                }">
                    <PlayerButton 
                        textLabel="Play video"
                        :custom="custom"
                    />
                </div>
            </transition>
            <transition name="fade">
                <div ref="pause" v-show="!ended" :class="{
                        'control control--play': 1,
                        'control--custom' : custom
                    }" 
                >
                    <PlayerButton 
                        textLabel="Pause video"
                        type="pause"
                        :custom="custom"
                    />
                </div>
            </transition>
            <video ref="video" :aria-label="getVideoLabel()" :poster="poster" preload>
                <source :src="video" type="video/mp4">
                <track :src="transcript" default kind="captions" srclang="en" label="English">
            </video>
        </div>
    </div>
    <video-transcript>
        <p>We are purpose driven and it shows</p>
        <p>1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19</p>
        <p>For 19 consecutive years we have been recognized as one of Canada’s Best Workplaces.</p>
        <p>Great Place to Work Best Workplaces 2008 Canada</p>
        <p>Great Place to Work Best Workplaces 2009 Canada</p>
        <p>Great Place to Work Best Workplaces 2010 Canada</p>
        <p>Great Place to Work Best Workplaces 2011 Canada</p>
        <p>Great Place to Work Best Workplaces 2012 Canada</p>
        <p>Great Place to Work Best Workplaces 2013 Canada</p>
        <p>Great Place to Work Best Workplaces 2014 Canada</p>
        <p>Great Place to Work Best Workplaces 2015 Canada</p>
        <p>Great Place to Work Best Workplaces 2016 Canada</p>
        <p>Great Place to Work Best Workplaces 2017 Canada</p>
        <p>Great Place to Work Best Workplaces 2018 Canada</p>
        <p>Great Place to Work Best Workplace 1000+ Employees 2019 Canada</p>
        <p>Great Place to Work Best Workplaces 2020 Canada</p>
        <p>Great Place to Work Best Workplaces 2021 Canada</p>
        <p>Great Place to Work Best Workplaces 2022 Canada</p>
        <p>Great Place to Work Best Workplaces 2023 Canada</p>
        <p>Great Place to Work Best Workplaces 2024 Canada</p>
        <p>Great Place to Work Best Workplaces 2025 Canada</p>
        <p>Great Place to Work Best Workplaces 2026 Canada</p>
        <p>At Doane Grant Thornton you can bring your whole self to work</p>
        <p>And thrive along side colleagues who support you both professionally and personally</p>
        <p>Discover your voice in an award winning culture</p>
        <p>That’s our purple, discover yours!</p>
    </video-transcript>
    </div>
</template>

<script>
import { videos } from '@/mixins/main'
import PlayerButton from '@/components/Ui/PlayerButton'
import VideoTranscript from '@/components/Ui/VideoTranscript'

export default {
    name: 'VideoAutoplay',
    props: {
        media: [String, Object],
        custom: Boolean,
        subtitles: {
            type: Boolean,
            default: true
        }
    },

    components: { 
        PlayerButton,
        VideoTranscript, 
    },

    mixins: [ videos ],

    data: () => ({
        ended: true,
        played: false,
    }),

    mounted() {
        const { video, play, pause } = this.$refs

        setTimeout( () => {

            play.addEventListener('click', () => {
                this.videoPlay( video, 1 )
            })
            pause.addEventListener('click', () => {
                this.videoPause( video )
            })

            video.addEventListener('play', () => {
                this.videoPlay( video )
            })
            video.addEventListener('ended', () => {
                this.videoPause( video )
            })

            if ( this.isMobile() ) video.addEventListener('click', () => {
                this.played ? this.videoPause( video ) : this.videoPlay( video )
            })

        })

    },

    methods: {
        getVideoLabel() {
            return 'Doane Grant Thornton Best Workplaces awards, English captions available'
        },
        videoPlay( vid, click ) {
            setTimeout( () => {
                this.played = true
                this.ended = false

                if ( click ) {
                    vid.play()
                } else {
                    this.$refs.pause.querySelector('button').focus()
                }
            }, 100)
        },
        videoPause( vid ) {
            this.played = false
            this.ended = true

            vid.pause()

            setTimeout( () => {
                this.$refs.play.querySelector('button').focus()
            }, 100)
        }
    },

    computed: {
        transcript() {
            return require('@/assets/videos/' + this.media + '.vtt')
        },
        poster() {
            return require('@/assets/videos/' + this.media + '.png')
        },
        autoplay() {
            return window.matchMedia('(min-width: 1281px)').matches && location.href.includes( this.when )
        }
    },
}
</script>

<style scoped>
.circle ::v-deep img {
    width: 100%;
    height: auto;
    position: static;
    border-radius: 1em;
}
</style>